import axios from "axios";
import jwtDecode from "jwt-decode";

export const api = axios.create({
  baseURL: "https://hcloud-api.herokuapp.com/",
});

export const localToken = localStorage.getItem("authToken") || "";

const decodedToken = localToken === "" ? "" : jwtDecode(localToken);

export const userID = Number(decodedToken.sub);

api.defaults.headers.authorization =
  localToken === "" ? "" : `Bearer ${localToken}`;
